export const cuotasAdicionalesOptions = [
  { key: "1", value: 0, text: "No" },
  { key: "2", value: 1, text: "1 cuota adicional" },
  { key: "3", value: 2, text: "2 cuotas adicionales" },
  { key: "4", value: 3, text: "3 cuotas adicionales" },
  { key: "5", value: 4, text: "4 cuotas adicionales" },
  { key: "6", value: 5, text: "5 cuotas adicionales" },
  { key: "7", value: 6, text: "6 cuotas adicionales" },
  { key: "8", value: 7, text: "7 cuotas adicionales" },
  { key: "9", value: 8, text: "8 cuotas adicionales" },
  { key: "10", value: 9, text: "9 cuotas adicionales" },
  { key: "11", value: 10, text: "10 cuotas adicionales" },
  { key: "12", value: 11, text: "11 cuotas adicionales" },
  { key: "13", value: 12, text: "12 cuotas adicionales" },
];
